module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "konfigurator-hotove-krmivo"
    }
  }, [_c('h1', [_vm._v("A je to! " + _vm._s(_vm.mazlicek.jmeno.value) + " má svůj vlastní Pettime")]), _vm._v(" "), (_vm.additional_info_header) ? _c('div', {
    staticClass: "summary-subtitle"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.additional_info_header.content)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.grandTexts) ? _c('div', {
    staticClass: "view-co-prinasi-krmivo-navic"
  }, [(_vm.grandTexts['pet-live'] && _vm.grandTexts['pet-live'].text_1) ? _c('div', {
    staticClass: "views-row"
  }, [_c('div', {
    staticClass: "views-field-field-krmivo-co-prinasi zivot",
    domProps: {
      "innerHTML": _vm._s(_vm.grandTexts['pet-live'].text_1)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.grandTexts['pet-live'] && _vm.grandTexts['pet-live'].text_2) ? _c('div', {
    staticClass: "views-row"
  }, [_c('div', {
    staticClass: "views-field-field-krmivo-co-prinasi zivot",
    domProps: {
      "innerHTML": _vm._s(_vm.grandTexts['pet-live'].text_2)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.grandTexts['pet-bread'] &&
    _vm.grandTexts['pet-bread'].text) ? _c('div', {
    staticClass: "views-row"
  }, [_c('div', {
    staticClass: "views-field-field-krmivo-co-prinasi rasa",
    domProps: {
      "innerHTML": _vm._s(_vm.grandTexts['pet-bread'].text)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.grandTexts['pet-alergic'] && _vm.grandTexts['pet-alergic'].text) ? _c('div', {
    staticClass: "views-row"
  }, [_c('div', {
    staticClass: "views-field-field-krmivo-co-prinasi alergie",
    domProps: {
      "innerHTML": _vm._s(_vm.grandTexts['pet-alergic'].text)
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block block-views contextual-links-region",
    attrs: {
      "id": "block-views-modelovy-pes-krmna-davka-block"
    }
  }, [_c('h2', [_vm._v("Denní dávka")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "view view-modelovy-pes-krmna-davka view-id-modelovy_pes_krmna_davka view-display-id-block view-dom-id-33c75cace5282ecc90658493756f026b"
  }, [_c('div', {
    staticClass: "view-content"
  }, [_c('div', {
    staticClass: "views-row views-row-1 views-row-odd views-row-first views-row-last"
  }, [_c('div', {
    staticClass: "views-field views-field-field-model-krmna-davka"
  }, [(_vm.isDataLoading) ? _c('div', {
    staticClass: "field-content"
  }, [_c('div', {
    staticClass: "krmna-davka-item"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.round(_vm.weightFeedRatio)) + " g / " + _vm._s(_vm.round((_vm.weightFeedRatio * 0.03527396195) * 10 | _vm.round) / 10) + " oz")])])]), _vm._v(" "), _c('div', {
    staticClass: "krmna-davka-item"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.round(_vm.energyRatio * 4.184)) + " kJ / " + _vm._s(_vm.round(_vm.energyRatio)) + " kcal")])])]), _vm._v(" "), (_vm.showTotalPrice) ? _c('div', {
    staticClass: "krmna-davka-item krmna-davka-item-cena"
  }, [_c('div', [_c('span', [_c('span', [_vm._v("Cena denní dávky")]), _c('span', [_vm._v("při objednávce na " + _vm._s(_vm.$store.state.mazlicek.krmivo.tydny.value) + " " + _vm._s(_vm.weeksReadableValue))])])]), _vm._v(" "), _c('div', [_c('span', [_vm._v(_vm._s((_vm.pricePerDay + '').replace('.', ',')) + " Kč")])])]) : _vm._e(), _vm._v(" "), (_vm.individualFeedWeight) ? _c('p', [_c('strong', [_vm._v("Váš pes má individuální krmnou dávku nastavenou na " + _vm._s(_vm.individualFeedWeight * 100) + "% vypočtené dávky.")])]) : _vm._e(), _vm._v(" "), (_vm.dailyCostText) ? _c('div', {
    staticClass: "krmna-davka-kafe"
  }, [_c('span', [_c('img', {
    attrs: {
      "src": _vm.dailyCostText.uri
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dailyCostText.text_1) + " " + _vm._s(_vm.dailyCostText.text_2))])]) : _vm._e()]) : _c('div', [_c('p', [_vm._v("Načítaní...")])]), _vm._v(" "), (_vm.mazlicek.krmivo.feedData && _vm.mazlicek.jeStene) ? _c('ul', _vm._l((_vm.mazlicek.krmivo.feedData.feedRatio.puppyInfo), function(value, key) {
    return _c('li', {
      key: key
    }, [_vm._v("\n                                        Týden: " + _vm._s(key + 1) + " / Dospělost: " + _vm._s(value.puppyStep) + " %\n                                        "), _c('ul', [_c('li', [_vm._v("Energický koeficient: " + _vm._s(value.energyCoefficient) + " %")]), _vm._v(" "), _c('li', [_vm._v("Energie krmné dávky: " + _vm._s(value.energyRatio) + " kj")]), _vm._v(" "), _c('li', [_vm._v("Váha: " + _vm._s(value.weight) + " kg")]), _vm._v(" "), _c('li', [_vm._v("Váha krmné dávky: " + _vm._s(value.weightFeedRatio) + " g")])])])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.$store.state.mazlicek.krmivo.tydny.value !== 0) ? _c('div', {
    staticClass: "views-field views-field-field-model-krmna-davka-upozorne"
  }, [(!_vm.mazlicek.jeStene) ? _c('span', {
    staticClass: "field-content",
    domProps: {
      "innerHTML": _vm._s(_vm.hmotnostFinalText)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.mazlicek.jeStene) ? _c('span', {
    staticClass: "field-content",
    domProps: {
      "innerHTML": _vm._s(_vm.pohybFinalText)
    }
  }) : _vm._e()]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "block block-views contextual-links-region",
    attrs: {
      "id": "block-views-a32ab1e314a9dc8bd354141155fe7218"
    }
  }, [_c('h2', [_vm._v("Složení")]), _vm._v(" "), _c('div', {
    staticClass: "summary-subtitle"
  }, [_vm._v("Skvělý výběr")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "slozky"
  }, [_c('div', {
    staticClass: "slozka-item slozka-masova"
  }, [_c('div', {
    staticClass: "slozka-item-inner"
  }, [_c('div', {
    staticClass: "slozka-icn"
  }, [_c('img', {
    attrs: {
      "src": _vm.getIconUrlById(_vm.slozky.masova.id, 'png'),
      "width": "60",
      "height": "60"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "slozka-nadpis",
    domProps: {
      "innerHTML": _vm._s(_vm.slozky.masova.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "slozka-popis",
    domProps: {
      "innerHTML": _vm._s(_vm.slozky.masova.description)
    }
  })])]), _vm._v(" "), _vm._l((_vm.selectedAdditionsBlocks), function(addition, key) {
    return _c('div', {
      key: key,
      staticClass: "slozka-item topping"
    }, [_c('div', {
      staticClass: "slozka-item-inner"
    }, [_c('div', {
      staticClass: "slozka-icn"
    }, [_c('img', {
      attrs: {
        "src": _vm.getIconUrlById(addition.id),
        "width": "60",
        "height": "60"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "slozka-nadpis",
      domProps: {
        "innerHTML": _vm._s(addition.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "slozka-popis",
      domProps: {
        "innerHTML": _vm._s(addition.description)
      }
    })])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "view view-modelovy-pes-slozeni-krmiva view-id-modelovy_pes_slozeni_krmiva view-display-id-block view-dom-id-23b9e06b8988b95edec87e7e36ba185c"
  }, [_c('div', {
    staticClass: "view-content"
  }, [_c('div', {
    staticClass: "views-row views-row-3 views-row-odd views-row-last"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "views-field views-field-field-model-slozeni-popis"
  }, [_c('div', {
    staticClass: "field-content"
  }, [_c('div', {
    staticClass: "composition-description",
    class: {
      colapsed: !_vm.compositionExpanded
    },
    domProps: {
      "innerHTML": _vm._s(_vm.composition)
    }
  }), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.compositionExpanded = !_vm.compositionExpanded
      }
    }
  }, [_vm._v("zobrazit " + _vm._s(_vm.compositionExpanded ? 'méně' : 'více'))])])])]), _vm._v(" "), (_vm.selectedAdditionsBlocks.length > 0) ? _c('div', {
    staticClass: "views-row views-row-3 views-row-odd views-row-last"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "views-field views-field-field-model-slozeni-popis"
  }, [_c('div', {
    staticClass: "field-content"
  }, [_c('p', _vm._l((_vm.selectedAdditionsBlocks), function(addition, key) {
    return _c('span', {
      key: key,
      domProps: {
        "innerHTML": _vm._s(addition.composition)
      }
    })
  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "views-row views-row-1 views-row-odd views-row-first"
  }, [_c('div', {
    staticClass: "views-field views-field-field-model-slozeni-popis"
  }, [_c('div', {
    staticClass: "field-content"
  }, [_vm._l((_vm.alergieFinalTexts), function(alergie, key) {
    return _c('span', {
      key: key
    }, [_vm._v(_vm._s(alergie.desc_final))])
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.slozeniText)
    }
  })], 2)])])])])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "block block-views contextual-links-region",
    attrs: {
      "id": "block-views-bc7371bc08ec7790d0b483d2e808194b"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "view view-modelovy-pes-analyza-prvek view-id-modelovy_pes_analyza_prvek view-display-id-block view-dom-id-ce0d6c32dbacad3f2acf37f751d2c6d3"
  }, [_c('div', {
    staticClass: "view-content"
  }, [_vm._l((_vm.analysis), function(value, name, key) {
    return _c('div', {
      key: key,
      staticClass: "views-row"
    }, [_c('div', {
      staticClass: "views-field views-field-field-model-slozka-ikona"
    }, [_c('div', {
      staticClass: "field-content"
    }, [_c('img', {
      attrs: {
        "typeof": "foaf:Image",
        "src": _vm.getIconUrl(value.name, 'icn-', '.svg'),
        "width": "50",
        "height": "50",
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "views-field views-field-field-model-slozka-procenta"
    }, [_c('div', {
      staticClass: "field-content"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(value.value + ' ' + value.unit)
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "views-field views-field-field-model-slozka-nazev"
    }, [_c('div', {
      staticClass: "field-content"
    }, [_vm._v("\n                                    " + _vm._s(value.title) + "\n                                ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "analyza-text",
    domProps: {
      "innerHTML": _vm._s(_vm.analyzaText)
    }
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "block block-views",
    attrs: {
      "id": "block-views-certifikaty-block"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "view view-certifikaty view-id-certifikaty view-display-id-block view-dom-id-0811530caefeb11cda25cd12b464a5b8"
  }, [_c('div', {
    staticClass: "view-content"
  }, _vm._l((_vm.certificates), function(certificate, key) {
    return _c('div', {
      key: key,
      staticClass: "views-row views-row-1 views-row-odd views-row-first"
    }, [_c('div', {
      staticClass: "views-field views-field-field-certifikat-ikona"
    }, [_c('div', {
      staticClass: "field-content"
    }, [_c('img', {
      attrs: {
        "typeof": "foaf:Image",
        "src": _vm.getCertificateImageUrl(certificate.uri),
        "width": "90",
        "height": "90",
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "views-field views-field-title"
    }, [_c('span', {
      staticClass: "field-content"
    }, [_vm._v(_vm._s(certificate.title))])]), _vm._v(" "), _c('div', {
      staticClass: "views-field views-field-field-certifikat-popis"
    }, [_c('div', {
      staticClass: "field-content"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(certificate.popis)
      }
    })])])])
  }), 0)])])]), _vm._v(" "), (_vm.$store.state.mazlicek.krmivo.tydny.value !== 0) ? _c('div', {
    staticClass: "priobjednavka"
  }, [_c('h2', [_vm._v("Přiobjednejte si navíc Pettime+")]), _vm._v(" "), _c('div', {
    staticClass: "summary-subtitle"
  }, [_vm._v("Postaráme se i o jeho duši")]), _vm._v(" "), _c('div', {
    staticClass: "priobjednavka-obsah"
  }, [_vm._l((_vm.additionalComponents), function(addition) {
    return _c('div', {
      key: addition.id,
      class: {
        disabled: _vm.selectedAdditions.indexOf(addition.id) < 0
      }
    }, [_c('div', {
      staticClass: "addition-content-wrapper"
    }, [_c('div', {
      staticClass: "addition-icn"
    }, [_c('img', {
      attrs: {
        "src": _vm.getIconUrlById(addition.id),
        "width": "60",
        "height": "60"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "addition-content"
    }, [_c('div', {
      staticClass: "addition-name"
    }, [_vm._v(_vm._s(addition.title))]), _vm._v(" "), _c('div', {
      staticClass: "addition-desc",
      domProps: {
        "innerHTML": _vm._s(addition.description)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "addition-price"
    }, [_vm._v("\n                                + " + _vm._s(_vm.getAdditionPrice(addition.g_na_dk, addition.cena_za_g)) + " Kč / den\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "button-wrapper"
    }, [(_vm.selectedAdditions.indexOf(addition.id) >= 0) ? _c('button', {
      staticClass: "remove-addition button",
      on: {
        "click": function($event) {
          return _vm.removeAddition(addition.id)
        }
      }
    }, [_vm._v("Odebrat\n                                ")]) : _c('button', {
      staticClass: "add-addition button",
      attrs: {
        "disabled": _vm.selectedAdditionsBlocks.length > 0
      },
      on: {
        "click": function($event) {
          return _vm.addAddition(addition.id)
        }
      }
    }, [_vm._v("Přiobjednat\n                                ")])])])])])
  }), _vm._v(" "), _vm._l((_vm.services), function(service) {
    return _c('div', {
      key: service.id
    }, [_c('div', {
      staticClass: "addition-content-wrapper"
    }, [_c('div', {
      staticClass: "addition-icn"
    }, [_c('img', {
      attrs: {
        "src": _vm.getIconUrl('mineralni'),
        "width": "60",
        "height": "60"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "addition-content"
    }, [_c('div', {
      staticClass: "addition-name"
    }, [_vm._v(_vm._s(service.title))]), _vm._v(" "), _c('div', {
      staticClass: "addition-desc",
      domProps: {
        "innerHTML": _vm._s(service.description)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "addition-price"
    }, [_vm._v("+ " + _vm._s(_vm.round(service.cena_za_den * _vm.tydnyKoeficient * 10) / 10) + " Kč / den\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "button-wrapper"
    }, [(_vm.selectedServices.indexOf(service.id) >= 0) ? _c('button', {
      staticClass: "remove-addition button",
      on: {
        "click": function($event) {
          return _vm.removeService(service.id)
        }
      }
    }, [_vm._v("Odebrat\n                                ")]) : _c('button', {
      staticClass: "add-addition button",
      on: {
        "click": function($event) {
          return _vm.addService(service.id)
        }
      }
    }, [_vm._v("Přiobjednat\n                                ")])])])])])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fixed-button"
  }, [_c('p', [(_vm.showTotalPrice) ? _c('span', {
    staticClass: "price-per-day"
  }, [_c('span', {
    staticClass: "views-label views-label-field-model-cena-davky"
  }, [_vm._v("\n                    Cena / den:\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "cena-den"
  }, [_vm._v("\n                    " + _vm._s((_vm.pricePerDay + '').replace('.', ',')) + " Kč\n                ")])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "button"
  }, [_vm._v("Přejít k objednávce")])])]), _vm._v(" "), _c('navigace', {
    attrs: {
      "showPrev": true,
      "onClickPrev": _vm.prev
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("Denní dávka")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("Denní energetický příjem")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "views-field views-field-field-model-slozeni-nadpis"
  }, [_c('div', {
    staticClass: "field-content"
  }, [_vm._v("Složení:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "views-field views-field-field-model-slozeni-nadpis"
  }, [_c('div', {
    staticClass: "field-content"
  }, [_vm._v("Složení Pettime+:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block block-views contextual-links-region",
    attrs: {
      "id": "block-views-acdd7429a9a1746103e25993bb79fcaa"
    }
  }, [_c('h2', [_vm._v("Analýza")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-015f1272","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/10HotoveKrmivo.vue
// module id = 563
// module chunks = 1